import SideBarLayout from "common/layouts/SideBarLayout/SideBarLayout";
import SideBarAudio from "modules/glifos-rich-media/components/SideBarAudio/SideBarAudio";
import SideBarVideo from "modules/glifos-rich-media/components/SideBarVideo/SideBarVideo";
import Alert from "modules/website/components/Alert/Alert";
import ContentCard from "modules/website/components/ContentCard/ContentCard";
import { useNewsPage } from "modules/website/hooks/useNewsPage";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./NewNewsView.module.scss";
import ApiURLs from "services/BackendApi/BackendApiURLs";
import SideBarDocument from "modules/glifos-rich-media/components/SideBarDocument/SideBarDocument";
import BasicLayout from "common/layouts/BasicLayout/BasicLayout";
import SearchSquareForm from "modules/glifos-rich-media/components/SearchSquareForm/SearchSquareForm";
import BrowseSquare from "modules/website/components/BrowseSquare/BrowseSquare";
import OptionCard from "modules/website/components/Category/OptionCard/OptionCard";
import Pagination from "modules/website/components/Pagination/Pagination";
import LoadingBody from "modules/website/components/loadingBody/loadingBody";

const secondStyleAlias = [
  {
    title: "Genocide Memorials",
    alias: "category/Memorials",
    noSideBar: true,
  },
  {
    title: "Unity and Reconciliation",
    alias: "category/Unity_and_Reconciliation",
    noSideBar: true,
  },
  {
    title: "Unity and Reconciliation",
    alias: "category/Unity_and_Reconciliation",
    noSideBar: true,
  },
  {
    title: "National Youth Council",
    alias: "category/National_Youth_Council",
    noSideBar: false,
  },
  {
    title: "AERG",
    alias: "category/AERG_programmes",
    noSideBar: false,
  },
  {
    title: "Peace and Love Proclaimers",
    alias: "category/Peace_and_Love_Proclaimers",
    noSideBar: false,
  },
  {
    title: "Idebate",
    alias: "category/Idebate",
    noSideBar: false,
  },
  {
    title: "Aegis Youth Department",
    alias: "category/Aegis_Youth_Department",
    noSideBar: false,
  },
  {
    title: "GAERG",
    alias: "category/GAERG",
    noSideBar: false,
  },
  {
    title: "Walk to Remember",
    alias: "category/Walk_to_Remember",
    noSideBar: false,
  },
  {
    title: "Job Opportunities",
    alias: "category/Job_Opportunities",
    noSideBar: true,
  },
];
export default function NewNewsView() {
  const navigate = useNavigate();
  const [sideBar, setSideBar] = useState(null);
  const location = useLocation();
  const alias = location.pathname.replace("/", "");
  const [page, setPage] = useState(1);
  const breadC = [{ title: "News", path: "/news" }];

  const { isLoading, isError, payload, error } = useNewsPage({
    page: 1,
    sortby: "isodate",
    orderby: "desc",
    page: page,
  });

  const url = new URL(window.location.href);
  const pageUrl = url.searchParams.get("page");

  useEffect(() => {
    setPage(pageUrl);
  }, [pageUrl]);

  if (isLoading) return <BasicLayout></BasicLayout>;

  if (isError) {
    navigate("/404");
  }

  if (!isLoading && !isError && payload && breadC) {
    return (
      <SideBarLayout
        title={payload.title}
        breadC={breadC}
        description={payload.description}
        leftBar={sideBar}
      >
        {isLoading && <LoadingBody />}
        {!isLoading && isError && <Alert variant="danger">{error}</Alert>}
        {!isLoading && !isError && payload && (
          <div>
            <div>
              <Pagination
                result_header={payload?.result_header}
                justify="end"
              />
            </div>
            <Row className={`${styles.rowCards}`}>
              {payload?.records?.record &&
                (Array.isArray(payload?.records?.record) ? (
                  payload?.records?.record.length > 0 ? (
                    payload?.records?.record?.map((item, index) => {
                      return secondStyleAlias.find(
                        (item) => item.alias === alias,
                      ) ? (
                        <Col key={index} md={12} lg={4} xl={4} className="mb-4">
                          <OptionCard
                            image={ApiURLs.baseURL + item.thumbnail}
                            title={item.title}
                            link={item.id}
                            description={item.blurb}
                          />
                        </Col>
                      ) : (
                        <Col key={index} md={12} lg={6} xl={6} className="mb-4">
                          <ContentCard
                            key={index}
                            title={item.title}
                            image={ApiURLs.baseURL + item.thumbnail}
                            description={item.blurb}
                            nav={item.id}
                            searchable={item.searchable}
                          />
                        </Col>
                      );
                    })
                  ) : (
                    <div className={`${styles.noFound}`}>
                      No results were found
                    </div>
                  )
                ) : (
                  <Col md={12} lg={4} className="mb-4">
                    {secondStyleAlias.find((item) => item.alias === alias) ? (
                      <OptionCard
                        title={payload?.records?.record.title}
                        image={
                          ApiURLs.baseURL + payload?.records?.record.thumbnail
                        }
                        description={payload?.records?.record.blurb}
                        link={payload?.records?.record.id}
                      />
                    ) : (
                      <ContentCard
                        title={payload?.records?.record.title}
                        image={
                          ApiURLs.baseURL + payload?.records?.record.thumbnail
                        }
                        description={payload?.records?.record.blurb}
                        nav={payload?.records?.record.id}
                      />
                    )}
                  </Col>
                ))}
            </Row>
            <Pagination
              result_header={payload?.result_header}
              justify="start"
            />
          </div>
        )}
      </SideBarLayout>
    );
  }
}

// Local Variables:
// apheleia-inhibit: nil
// End:
